if (window.Groupon == null) {
  window.Groupon = {};
}

if (Groupon.Performance == null) {
  Groupon.Performance = {};
}

Groupon.Performance.pageReady = function() {
  if (typeof BOOMR.page_ready === 'function') {
    return BOOMR.page_ready();
  } else {
    return BOOMR.t_done = new Date().getTime();
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9wZXJmb3JtYW5jZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3BlcmZvcm1hbmNlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUEyQixzQkFBM0I7RUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixHQUFqQjs7OztFQUNBLE9BQU8sQ0FBQyxjQUFlOzs7QUFFdkIsT0FBTyxDQUFDLFdBQVcsQ0FBQyxTQUFwQixHQUFnQyxTQUFBO0VBQzlCLElBQUcsT0FBTyxLQUFLLENBQUMsVUFBYixLQUEyQixVQUE5QjtXQUNFLEtBQUssQ0FBQyxVQUFOLENBQUEsRUFERjtHQUFBLE1BQUE7V0FHRSxLQUFLLENBQUMsTUFBTixHQUFtQixJQUFBLElBQUEsQ0FBQSxDQUFNLENBQUMsT0FBUCxDQUFBLEVBSHJCOztBQUQ4QiJ9
